import type { ReactNode } from 'react'
import styles from './Teams.module.css'

export interface TeamsProps {
  children?: ReactNode
  newTeamModal?: ReactNode
}

/**
 * Teams screen
 */
export function Teams({ children, newTeamModal }: TeamsProps) {
  return (
    <>
      <div className={styles.root}>{children}</div>
      {newTeamModal}
    </>
  )
}
